module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "left sink"
  }, [_c('em', [_vm._v("With love and gratitude for my friends Julia, Niels, Agnieszka, Cornelia, HaJo, Verena, Andrea, Antonie, Neithardt, Kirsten, Sahar, Evgenjia, Jörg, and Martina. And, of course, for you, Otti.")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("And you, Poldi.")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("Namaste!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-208ff0a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 66
// module chunks = 0